import { render } from "./NavbarSideLink.vue?vue&type=template&id=31998303"
import script from "./NavbarSideLink.vue?vue&type=script&lang=ts"
export * from "./NavbarSideLink.vue?vue&type=script&lang=ts"
script.render = render

export default script